import { useMemo } from "react";
import useDocs from "./useDocs";
import { DocsKind } from "./constants";
import usePropsDocs from "./usePropsDocs";
import { flattenCommentArray } from "./utils";

const useComponentDocs = (entry, propsEntry, namespace) => {
  const docs = useDocs(
    entry,
    [DocsKind.Function, DocsKind.Class, DocsKind.Variable],
    namespace
  );
  const propsDocs = usePropsDocs(propsEntry, namespace);

  return useMemo(() => {
    if (!docs) return null;

    const { name, kind, signatures, comment } = docs;

    if (kind === DocsKind.Class) {
      // class component
      return {
        name,
        description: flattenCommentArray(comment?.summary),
        props: propsDocs?.props,
      };
    }

    // function component
    const signature =
      Array.isArray(signatures) && signatures.length > 0 ? signatures[0] : {};

    return {
      name,
      description: flattenCommentArray(signature.comment?.summary),
      props: propsDocs?.props,
    };
  }, [docs, propsDocs]);
};

export default useComponentDocs;
